module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALSO BY"), _c('br')]), _vm._v(" "), _c('br'), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JEAN-CLAUDE IZZO")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609454401/total-chaos",
      "target": "_blank"
    }
  }, [_vm._v("Total Chaos")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781609451271/chourmo",
      "target": "_blank"
    }
  }, [_vm._v("Chourmo")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781933372594/a-sun-for-the-dying",
      "target": "_blank"
    }
  }, [_vm._v("A Sun for the Dying")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781933372358/the-lost-sailors",
      "target": "_blank"
    }
  }, [_vm._v("The Lost Sailors")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Living Tires")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-222dc75c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/solea_00001.vue
// module id = 63
// module chunks = 0